// extracted by mini-css-extract-plugin
module.exports = {"FilterBadgeList":"FilterBadges_FilterBadgeList__nKe70","FilterBadge":"FilterBadges_FilterBadge__rXXNl","code":"FilterBadges_code__j5SCy","value":"FilterBadges_value___dIo_"};